import { useState } from 'react';
import axios from 'axios';
import {
  Input, Select, Modal, Form, Row, Col, App as AntApp,
} from 'antd';
import { API_URL } from '../../config';
import type { BacklogItem } from './types';
import { CAT_INFO, PRIO_INFO, MODULOS } from './types';
import { getToken } from './utils';

// Modal pra criar ou editar item de backlog.
export default function ModalBacklogItem({ item, onClose, onSalvo }: {
  item: BacklogItem | null; onClose: () => void; onSalvo: () => void;
}) {
  const { message } = AntApp.useApp();
  const [titulo, setTitulo] = useState(item?.titulo || '');
  const [descricao, setDescricao] = useState(item?.descricao || '');
  const [categoria, setCategoria] = useState(item?.categoria || 'melhoria');
  const [modulo, setModulo] = useState(item?.modulo || '');
  const [prioridade, setPrioridade] = useState(item?.prioridade || 'media');
  const [salvando, setSalvando] = useState(false);

  async function salvar() {
    if (!titulo.trim()) { message.warning('Título obrigatório'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      const body: any = {
        action: item ? 'backlog_sys_atualizar' : 'backlog_sys_criar',
        titulo, descricao: descricao || null, categoria,
        modulo: modulo || null, prioridade,
      };
      if (item) body.id = item.id;
      await axios.post(`${API_URL}/agentes/exemplos`, body, { headers: { Authorization: token } });
      message.success('Salvo.');
      onSalvo();
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <Modal open onCancel={onClose} onOk={salvar} confirmLoading={salvando} width={620} destroyOnClose
      title={item ? 'Editar item do backlog' : 'Novo item no backlog'}
      okText={item ? 'Atualizar' : 'Adicionar'} cancelText="Cancelar">
      <Form layout="vertical" size="small">
        <Form.Item label="Título" required>
          <Input value={titulo} onChange={e => setTitulo(e.target.value)}
            placeholder="Ex.: Botão excluir composição não confirma duas vezes" autoFocus />
        </Form.Item>
        <Form.Item label="Descrição (opcional)">
          <Input.TextArea value={descricao} onChange={e => setDescricao(e.target.value)}
            rows={4} placeholder="Detalhes, contexto, passos pra reproduzir..." />
        </Form.Item>
        <Row gutter={10}>
          <Col span={8}>
            <Form.Item label="Categoria">
              <Select value={categoria} onChange={(v) => setCategoria(v)}
                options={Object.entries(CAT_INFO).map(([k, v]) => ({ label: `${v.icon} ${v.label}`, value: k }))} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Prioridade">
              <Select value={prioridade} onChange={(v) => setPrioridade(v)}
                options={Object.entries(PRIO_INFO).map(([k, v]) => ({ label: v.label, value: k }))} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Módulo">
              <Select value={modulo || undefined} onChange={(v) => setModulo(v || '')}
                allowClear placeholder="qualquer"
                options={MODULOS.map(m => ({ label: m, value: m }))} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
